<script>
  import RadioGroup from "../../../../components/input/RadioGroup.svelte";
  import DialogContent from "../../../../components/dialog/DialogContent.svelte";
  import DialogSplitter from "../../../../components/dialog/DialogSplitter.svelte";
  import DialogTitle from "../../../../components/dialog/DialogTitle.svelte";
  import DialogBottomControls from "../../../../components/dialog/DialogBottomControls.svelte";
  import DialogBottomControlButton from "../../../../components/dialog/DialogBottomControlButton.svelte";
  import {translate} from "../../../../i18n/i18next.js";
  import { useLicenseData } from "../../../../hooks/license/useLicenseData.js";
  import { derived } from "svelte/store";

  export let selectedAuthMethod
  export let onClickNext
  export let onClickClose

  const licenseData = useLicenseData()
  const currentAuthMethod = derived(licenseData, data => data?.authMethod)

  $: {
    if ($currentAuthMethod === "eProtector" || $currentAuthMethod === "invalidEProtector") selectedAuthMethod = "online"
    if ($currentAuthMethod === "online" || $currentAuthMethod === "invalidOnlineLicense") selectedAuthMethod = "eProtector"
  }
</script>

<DialogTitle title={translate("frontend:components.changeLicenseAuthenticationMethodDialog.authMethodSelection.title")}/>
<DialogSplitter/>
<DialogContent>
  <div>
    {translate("frontend:components.changeLicenseAuthenticationMethodDialog.authMethodSelection.caption")}
  </div>
  <div style="display: flex; gap: 1rem; justify-content: space-between">
    <RadioGroup
      options={[
        {
          value: "eProtector",
          translationKey: "generic.license.protectors.eProtector",
          disabled: $currentAuthMethod === "eProtector" || $currentAuthMethod === "invalidEProtector"
        },
        {
          value: "online",
          translationKey: "generic.license.protectors.online",
          disabled: $currentAuthMethod === "online" || $currentAuthMethod === "invalidOnlineLicense"
        }
      ]}
      bind:value={selectedAuthMethod}
    />
  </div>
</DialogContent>
<DialogSplitter/>
<DialogBottomControls>
  <DialogBottomControlButton type="primary" onClick={onClickNext}>
    {translate("generic.next")}
  </DialogBottomControlButton>
  <DialogBottomControlButton type="secondary" onClick={onClickClose}>
    {translate("generic.cancel")}
  </DialogBottomControlButton>
</DialogBottomControls>
